import { render, staticRenderFns } from "./Prospectus.vue?vue&type=template&id=6976daae&scoped=true"
import script from "./Prospectus.vue?vue&type=script&lang=js"
export * from "./Prospectus.vue?vue&type=script&lang=js"
import style0 from "./Prospectus.vue?vue&type=style&index=0&id=6976daae&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6976daae",
  null
  
)

export default component.exports